const enSystemActivityEvents = {
  tableColumns: {
    createdDateTime: 'Date',
    code: 'Code',
    logLevel: 'Log level',
    event: 'Event',
    tags: 'Tags',
    creator: 'Created',
    emsPartyId: 'Owner ID',
    emsPartyName: 'Owner name',
    balancingGroupId: 'Balancing group ID',
    balancingGroupName: 'Balancing group',
    deviceId: 'Device ID',
    deviceName: 'Device'
  },
  filter: {
    dateTimeFilterValue: 'Value',
    beforeFilterLabel: 'is before',
    onOrAfterFilterLabel: 'is after'
  },
  dateFrom: 'Date from',
  dateTo: 'Date to',
  dateRangeError: 'Enter max week date range'
};

export default enSystemActivityEvents;
